import {useEffect, useRef, useState} from 'react'
import {useCrud} from '../../../services/loggedin/CrudContext'
import {Highcharts} from './highcartConfig'
import HighchartsReact from 'highcharts-react-official'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {useIntl} from 'react-intl'
import {set} from 'date-fns'
import {Form} from 'react-bootstrap'
const MySwal = withReactContent(Swal)

export const ChartsComponent = (props) => {
  let children = props.children ? props.children : null
  let baseChartOptions = props.baseChartOptions ? props.baseChartOptions : {}
  let setLoading = props.setLoading ? props.setLoading : () => {}
  const {library} = useCrud()
  let filterData = props.filterData ? props.filterData : null
  const [showChart, setShowChart] = useState(false)
  const [chartData, setChartData] = useState<any>(null)
  const [rawChartData, setRawChartData] = useState<any>(null)
  const disableError = props.disableError ? props.disableError : false
  const intl = useIntl()
  useEffect(() => {
    const fetchChart = async () => {
      if (!filterData) {
        setShowChart(false)
        return
      }
      setShowChart(false)
      setLoading(true)
      console.log('filterData', filterData)
      let crtData = await library?.getChart(filterData)
      console.log('crtData.data', crtData.data)
      setRawChartData(crtData.data)
      if (
        !disableError &&
        (crtData.data.series === undefined || crtData.data.series.length === 0)
      ) {
        setShowChart(false)
        setLoading(false)

        MySwal.fire({
          title: intl.formatMessage({id: 'GENERIC.NO_DATA_TITLE'}),
          text: intl.formatMessage({id: 'GENERIC.NO_DATA_TEXT'}),
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: intl.formatMessage({id: 'GENERIC.OK'}),
        })
        return
      }

      let chartOption = {...baseChartOptions}

      if (chartOption.drilldown !== undefined && crtData.data.drilldown !== undefined) {
        console.log('drilldown', crtData.data.drilldown)
        chartOption.drilldown = crtData.data.drilldown
      }
      if (crtData.data.xAxisDict !== undefined) {
        chartOption.xAxis = crtData.data.xAxisDict
        chartOption.xAxis.crosshair = true
        if (chartOption.otherXAxis) {
          chartOption.xAxis = {...chartOption.xAxis, ...chartOption.otherXAxis}
          chartOption.otherXAxis = undefined
        }
      }
      if (
        chartOption.series !== undefined &&
        crtData.data.series !== undefined &&
        crtData.data.motionlabels === undefined
      ) {
        chartOption.series = crtData.data.series
      } else {
        let series: any = []
        for (let i of crtData.data.seriesrange) {
          if (series[i] === undefined) {
            series[i] = []
          }

          let points = crtData.data.series[i].data
          points = points.map((point: any) => {
            return point.sequence[0]
          })
          series[i].data = points
          series[i].name = crtData.data.series[i].name
          chartOption.series = series
        }
      }
      console.log('chartOption before sort', chartOption.series)
      let oseries: any = JSON.parse(JSON.stringify(chartOption.series))
      try {
        if (!props.withMotion) {
          for (let i in chartOption.series) {
            let data = chartOption.series[i].data

            if (data && data.length > 0 && data[0].name !== undefined) {
              data.sort((a: any, b: any) => {
                if (a.name < b.name) {
                  return -1
                }
                if (a.name > b.name) {
                  return 1
                }
                return 0
              })
              chartOption.series[i].data = data
            }
          }
        }
      } catch (e) {
        chartOption.series = oseries
      }

      if (chartOption.drilldown !== undefined) {
        for (let i in chartOption.drilldown.series) {
          let data = chartOption.drilldown.series[i]

          if (data && data.length > 0) {
            data.sort((a: any, b: any) => {
              if (a.name < b.name) {
                return -1
              }
              if (a.name > b.name) {
                return 1
              }
              return 0
            })
          }

          chartOption.drilldown.series[i] = data

          let dataDrill = chartOption.drilldown.series[i].data

          if (dataDrill && dataDrill.length > 0) {
            dataDrill.sort((a: any, b: any) => {
              if (a[0] < b[0]) {
                return -1
              }
              if (a[0] > b[0]) {
                return 1
              }
              return 0
            })
            console.log('dataDrill', dataDrill)
            chartOption.drilldown.series[i].data = dataDrill
          }
        }
      }
      console.log('chartOption', chartOption)
      setShowChart(true)
      setChartData(chartOption)
      setLoading(false)
    }
    setTimeout(() => {
      fetchChart()
    }, 500)
  }, [filterData])

  const chartOnly = props.chartOnly ? props.chartOnly : false
  if (chartOnly) {
    return (
      <>
        {!showChart && (
          <div className='text-center'>
            <img
              style={{maxWidth: '250px', marginTop: '150px'}}
              src='/media/bars.svg'
              alt='preview'
            />
          </div>
        )}
        {showChart && (
          <>
            <InnerChart
              withMotion={props.withMotion}
              rawChartData={rawChartData}
              chartData={chartData}
            />
          </>
        )}
      </>
    )
  }
  return (
    <>
      <div className='row  gy-5 g-xl-8'>
        <div className='col-md-4'>
          <div className='card mb-5 mb-xl-10 card-md-stretch'>
            <div className='card-body'>{children}</div>
          </div>
        </div>

        <div className='col-md-8'>
          <div className='card mb-5 mb-xl-10 card-md-stretch'>
            <div className='card-body'>
              {!showChart && (
                <div className='text-center'>
                  <img
                    src='/media/bars.svg'
                    alt='preview'
                    className='mh-250px mt-3'
                    style={{marginTop: '150px'}}
                  />
                </div>
              )}
              {showChart && (
                <>
                  <InnerChart
                    withMotion={props.withMotion}
                    rawChartData={rawChartData}
                    chartData={chartData}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const PlayCharts = (props: any) => {
  let motion_series = props.motion_series ? props.motion_series : []
  let motion_labels = props.motion_labels ? props.motion_labels : []
  let motion_range = props.motion_range ? props.motion_range : []
  let onSetSeries = props.onSetSeries ? props.onSetSeries : () => {}
  let motion_label = props.motion_label ? props.motion_label : ''

  const [isPlaying, setIsPlaying] = useState(false)
  const [positionPerc, setPositionPerc] = useState(0)
  const [intervalId, setIntervalId] = useState<any>(null)
  const [positionIndex, sertPositionIndex] = useState(0)
  const [isStopped, setIsStopped] = useState(false)
  const [seconds, setSeconds] = useState(1)
  const intl = useIntl()
  useEffect(() => {
    const handleDocumentMouseUp = (event) => {
      if (event.button !== 2) {
        setTimeout(() => setIsStopped(false), 10)
      }
    }

    document.addEventListener('mouseup', handleDocumentMouseUp)
    return () => {
      document.removeEventListener('mouseup', handleDocumentMouseUp)
    }
  }, [])
  useEffect(() => {
    if (isPlaying && !isStopped) {
      if (intervalId !== null) {
        return
      }
      const interval = setInterval(() => {
        setPositionPerc((prev) => {
          console.log('prev', prev)
          if (prev >= 100) {
            sertPositionIndex(0)
            return 0
          }
          let newIndex = Math.floor((motion_labels.length * prev + 0.01) / 100)
          sertPositionIndex(newIndex)
          return prev + 0.1
        })
      }, 50)
      setIntervalId(interval)
      return () => clearInterval(interval)
    } else {
      if (intervalId === null) {
        return
      }

      clearInterval(intervalId)
      setIntervalId(null)
    }
  }, [isPlaying, isStopped])

  useEffect(() => {
    let series: any = []
    for (let i of motion_range) {
      if (series[i] === undefined) {
        series[i] = []
      }

      let points = motion_series[i].data
      points = points.map((point: any) => {
        return point.sequence[positionIndex]
      })
      series[i].data = points
      series[i].name = motion_series[i].name
    }

    onSetSeries(series)
  }, [positionIndex])

  return (
    <>
      <div style={{width: '100%', position: 'relative'}}>
        <div className='d-flex'>
          <button
            className='btn btn-primary'
            style={{
              borderRadius: '50px',
              padding: '10px',

              margin: 0,
              width: '41px',
              height: '41px',
            }}
            onClick={(e) => {
              setIsPlaying(!isPlaying)
            }}
          >
            {!isPlaying && <i className='fa fa-play p-0'></i>}
            {isPlaying && <i className='fa fa-pause p-0'></i>}
          </button>
          <input
            type='range'
            style={{marginTop: '3px', marginLeft: '20px', width: '100%', accentColor: '#AE0F09'}}
            value={positionPerc}
            onMouseDown={() => {
              setIsStopped(true)
            }}
            onMouseUpCapture={() => {
              setIsStopped(false)
            }}
            onChange={(e: any) => {
              setPositionPerc(parseFloat(e.target.value))
              sertPositionIndex(Math.floor((motion_labels.length * e.target.value) / 100))
            }}
          />
        </div>
        <label style={{position: 'absolute', top: '-5px', left: '60px'}} className='fw-bold'>
          {motion_label} {motion_labels[positionIndex]}
        </label>
      </div>
    </>
  )
}

const InnerChart = (props) => {
  const intl = useIntl()
  const crg = useRef<any>(null)
  const chartData = props.chartData
  const rawChartData = props.rawChartData
  return (
    <>
      {chartData.series && chartData.series.length === 0 && (
        <>
          <div
            style={{
              position: 'absolute',
              zIndex: 999999,
              top: '109px',
              textAlign: 'center',
              width: '100%',
              left: '0',
              fontSize: '25px',
              fontWeight: '100',
            }}
          >
            {intl.formatMessage({id: 'GENERIC.NO_DATA_TEXT_GEN'})}
          </div>
        </>
      )}
      {chartData.series && (
        <HighchartsReact highcharts={Highcharts} ref={crg} options={chartData} {...props} />
      )}
      {props.withMotion &&
        rawChartData &&
        rawChartData.motionlabels !== undefined &&
        rawChartData.seriesrange !== undefined && (
          <PlayCharts
            motion_series={rawChartData.series}
            motion_labels={rawChartData.motionlabels}
            motion_range={rawChartData.seriesrange}
            motion_label={chartData.motion.label ?? ''}
            onSetSeries={(series: any) => {
              const chartOptions = {...chartData}
              if (chartOptions && chartOptions.series !== undefined) {
                chartOptions.series = series

                for (let i in crg.current.chart.series) {
                  crg.current.chart.series[i].setData(series[i].data)
                }
              }
            }}
          />
        )}
    </>
  )
}
